<template>
<div class="filter-body" >
    <div class="form-group"><label for=""> Copy Writing Status</label>
        <div class="form-check" v-for="(filter,index) in copyWrittenFilters">
            <label class="form-check-label"><input checked="" class="form-check-input" name="copy_written" type="radio" :value="filter.key" :checked="index === 0">{{filter.name}}</label>
        </div>
    </div>
    <div class="form-group"><label for=""> Copy Review Status</label>
        <div class="form-check" v-for="(filter,index) in copyReviewFilters">
            <label class="form-check-label"><input checked="" class="form-check-input" name="completion_review" type="radio" :value="filter.key" :checked="index === 0">{{filter.name}}</label>
        </div>
    </div>
    <div class="form-group"><label for=""> Push to Magento Status</label>
        <div class="form-check" v-for="(filter,index) in magentoFilters">
            <label class="form-check-label"><input checked="" class="form-check-input" name="pushed_magento" type="radio" :value="filter.key" :checked="index === 0">{{filter.name}}</label>
        </div>
    </div>
</div>
</template>

<script>
export default {
  data: function () {
    return {
      copyWrittenFilters: [
        { 'name': 'All', 'key': '' },
        { 'name': 'Yes', 'key': 1 },
        { 'name': 'No', 'key': 0 }
      ],
      copyReviewFilters: [
        { 'name': 'All', 'key': '' },
        { 'name': 'Complete', 'key': 1 },
        { 'name': 'Incomplete', 'key': 0 }
      ],
      magentoFilters: [
        { 'name': 'All', 'key': '' },
        { 'name': 'Success', 'key': 'success' },
        { 'name': 'Failed', 'key': 'failed' },
        { 'name': 'Not attempted', 'key': null }
      ]
    }
  },
  mounted: function () {
    $('.select2').select2()
  }
}
</script>

<style scoped>

</style>
